import { useRef } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { aboutus1, aboutus2 } from "../helper/utils";
import "./pages.css"

const AboutUs = () => {

    const titleRef = useRef(null);
    const storyRef = useRef(null);
    const teamRef = useRef(null);
    const approachRef = useRef(null);

    useScrollAnimation([titleRef, storyRef, teamRef, approachRef]);

    return (
        <div className="max-width-about-class main-class">
            <div ref={titleRef} className="animate-on-scroll">
                <p className='get-in-touch-text-contact'>About Us</p>
                <div className='line-separator-contact-page'></div>
            </div>

            <div className="about-main">

                <div ref={storyRef} className="about-container animate-on-scroll">
                    {/* Left Column: Our Story & About Us Title */}
                    <div className="about-left" style={{ justifyContent: 'flex-end' }}>
                        <div>
                            <p className="get-in-touch-text">Our Story</p>
                            <div className="line-separator-contact none" />
                        </div>
                        <div style={{ flex: 0.3 }} />
                    </div>

                    {/* Right Column: Image & Description */}
                    <div className="about-right">
                        <img src={aboutus1} alt="About Us 1" className="about-us-img" />
                        <p className="aboutus-text-details">
                            <span className="hero-text">F</span>ounded in the bustling city of Ahmedabad, ND Tailor has been a trusted name in tailoring for over a decade. Our commitment to quality and customer satisfaction has made us a favorite among locals. We believe in creating garments that not only fit well but also tell a story of craftsmanship and care.
                        </p>
                    </div>
                </div>

                <div ref={teamRef} className="about-container-2 animate-on-scroll">


                    {/* Right Column: Image & Description */}
                    <div className="about-right">
                        <img src={aboutus2} alt="About Us 1" className="about-us-img" />
                        <p className="aboutus-text-details">
                            <span className="hero-text">W</span>ith a combined experience of over 25 years, our team at ND Tailor is a blend of skilled artisans, seasoned tailors, and passionate stylists. Based in Ahmedabad, our team brings together the best of traditional craftsmanship and contemporary design. Our artisans are not only experts in their craft but also deeply committed to delivering exceptional service and creating an unparalleled client experience.
                        </p>
                    </div>


                    {/* Left Column: Our Story & About Us Title */}
                    <div className="about-left" style={{ justifyContent: 'flex-end' }}>
                        <div>
                            <p className="get-in-touch-text">Our Team</p>
                            <div className="line-separator-contact none" />
                        </div>
                        <div style={{ flex: 0.3 }} />
                    </div>
                </div>


                <div ref={approachRef} className="approach-container animate-on-scroll">
                    <p className="get-in-touch-text-contact">Our Approach</p>

                    <div className='line-separator'></div>
                    <p className='hero-text-3'>From the initial consultation to the final fitting, we ensure a seamless experience tailored to your needs. Our process is designed to provide you with garments that are not only stylish but also comfortable and durable.</p>
                    <div className='line-separator'></div>
                </div>

            </div>
        </div>
    );
};

export default AboutUs;
